import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthForm from '../components/AuthForm';

const Login: React.FC = () => {
  const navigate = useNavigate();

  // New members go to the Welcome experience first; returning members go home.
  const handleAuthSuccess = (mode: 'login' | 'signup') => {
    navigate(mode === 'signup' ? '/welcome' : '/');
  };

  return (
    <div className="fixed inset-0 bg-dark-bg overflow-auto">
      <AuthForm onAuthSuccess={handleAuthSuccess} />
    </div>
  );
};

export default Login;

